import React from 'react';

interface CustomProps {
  value: string;
  bold?: boolean;
  record: {
    shortName: string;
    color: string;
  };
}
const Component: React.SFC<CustomProps> = (props) => {
  const { value } = props;
  const color = props.record.color ? props.record.color : '#faefb1';
  const style = {
    color: '#000',
    backgroundColor: color,
    fontSize: '.75rem',
    width: '45px',
    minWidth: '45px',
    height: '45px',
    lineHeight: '45px',
    marginRight: '10px',
  };
  return props.bold ? (
    <div className="CrudTextField">
      <span className="table-tbody__item--color" style={style}>
        {props.record.shortName}
      </span>
      <span className="table-tbody__item--bold">{value}</span>
    </div>
  ) : (
    <div className="CrudTextField">
      <span className="course-header__code">{props.record.shortName}</span>
      <span>{value}</span>
    </div>
  );
};

Component.propTypes = {};

Component.defaultProps = {
  bold: false,
};

export default Component;
